'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Logo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./logo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Logo component
 * @returns {Element} React element
 * @constructor
 */
var _ref = (0, _jsx3.default)('div', {
  className: 'l-login-component__logo'
});

function Logo() {
  return _ref;
}
//# sourceMappingURL=logo.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/logo/logo.js
// module id = 495
// module chunks = 0